import React, { Component } from 'react';
import WistiaPlayer from './WistiaPlayer';
import AzureVideoPlayer from './AzureVideoPlayer';

class VideoPlayer extends Component {
  render() {
    const {
      videoUrl,
      thumbUrl,
      onEndEvent,
      editable,
      completionType,
      videoMeta,
      updateVideoData,
      blockPerformance,
      videoDurationAvailale,
      uniqueId
    } = this.props;
    const { azureVideoOptions } = this.props;
    const { wistiaPlayerOptions } = this.props;
    const meta = JSON.parse(videoMeta || '{}');
    const allowSeekAhead = typeof meta.allowSeekAhead === 'boolean' ? meta.allowSeekAhead : true;

    if (videoUrl && videoUrl.startsWith('wistiaId:')) {
      return (
        <WistiaPlayer
          editable={editable}
          allowSeekAhead={allowSeekAhead}
          videoId={videoUrl.replace('wistiaId:', '')}
          thumbUrl={thumbUrl}
          onEndEvent={onEndEvent}
          wistiaPlayerOptions={wistiaPlayerOptions}
          updateVideoData={updateVideoData}
          blockPerformance={blockPerformance}
          uniqueId={uniqueId}
          completionType={completionType}
          videoDurationAvailale={videoDurationAvailale}
          useEventsHelper={this.props.useEventsHelper}
          preview={this.props.preview}
          completionStatus={this.props.completionStatus}
        />
      );
    }
    if (videoUrl && videoUrl.includes('filestackcontent')) {
      return (
        <video
          style={{ width: '100%' }}
          className="nativeVideo"
          src={videoUrl}
          controls={true}
          autoPlay={false}
        />
      );
    }
    return (
      <AzureVideoPlayer
        azureVideoOptions={azureVideoOptions}
        allowSeekAhead={allowSeekAhead}
        videoUrl={videoUrl}
        thumbUrl={thumbUrl}
        uniqueId={uniqueId}
        onEndEvent={onEndEvent}
        updateVideoData={updateVideoData}
        blockPerformance={blockPerformance}
        completionType={completionType}
        videoDurationAvailale={videoDurationAvailale}
        preview={this.props.preview}
        editable={editable}
        completionStatus={this.props.completionStatus}
      />
    );
  }
}

export default VideoPlayer;
